document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-size-guide-open]');
  if (!openBtn) return;

  const modal = document.querySelector('[data-size-guide-modal]');
  if (!modal) return;

  modal.showModal();
});

document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('[data-size-guide-close]');
  if (!closeBtn) return;

  const modal = closeBtn.closest('[data-size-guide-modal]') || document.querySelector('[data-size-guide-modal]');
  if (!modal) return;

  modal.close();
});

// Close on backdrop click
document.addEventListener('mousedown', (e) => {
  console.log('CCI');
  const modal = document.querySelector('[data-size-guide-modal]');
  if (!modal || !modal.open) return;

  if (e.target === modal) modal.close();
});
